import WithSidebar from 'Layout/WithSidebar';
import BenefitsBox from 'components/BenefitsBox';
import GeneralInfoBox from 'components/GeneralInfoBox';
import NavigationSideBar from 'components/NavigationSideBar';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';
import PDFBox from 'components/PDFBox';
import PictureComponent from 'components/PictureComponent';
import ProductItemsBox from 'components/ProductItemsBox';
import CropNutritionBox from 'components/ProductItemsBox/CropNutritionBox';
import RelatedProductsBox from 'components/ProductItemsBox/RelatedProductsBox';
import ProductItemsBoxWithTabs from 'components/ProductItemsBox/TrialResultsBoxWithTabs';
import YoutubeLink from 'components/YoutubeLink';
import { ROUTES } from 'constants/routes';
import { createRef, useEffect, useState } from 'react';

const getContentByKey = (key, data) => {
    switch (key) {
        case 'general_information': {
            const { main_title, general_information } = data;
            return (
                <GeneralInfoBox>
                    {main_title && <h3>{main_title}</h3>}
                    <div dangerouslySetInnerHTML={{ __html: general_information }}></div>
                    {/* TODO what about this button ? */}
                    {/* <Button type="read-more">READ MORE</Button> */}
                </GeneralInfoBox>
            );
        }
        case 'general_information_image':
            return <PictureComponent srcBig={data} alt="info" className="pb-8" />;
        case 'benefits_data': {
            const { benefits_preview_video, benefits_preview_text, benefits_video } = data.video || {};
            return (
                <BenefitsBox title={data.main_title} data={data.benefits}>
                    <YoutubeLink image={benefits_preview_video} href={benefits_video} title={benefits_preview_text} />
                </BenefitsBox>
            );
        }

        case 'composition_compatibility': {
            const { main_title, composition_compatibility } = data;
            return <PDFBox title={main_title} data={composition_compatibility} />;
        }
        case 'related_products': {
            return <RelatedProductsBox title={data.main_title} />;
        }
        case 'nutrition_programs':
            return <CropNutritionBox title={data.main_title} />;
        case 'trial_results':
            return <ProductItemsBoxWithTabs title={data.main_title} />;

        default:
            return null;
    }
};
// TODO NOT DONE!!!
const AboutProductPageContent = ({ pageContentData }) => {
    const [sectionsData, setSectionsData] = useState({});
    const [activeIndex, setActiveIndex] = useState(0);
    const pageContent = [];
    const sidebarTitles = [];
    console.log(pageContentData);
    Object.entries(pageContentData).forEach(([key, value]) => {
        // adjust this for empty blocks
        if ((value && Object.keys(value).length !== 0) || value?.length) {
            pageContent.push(getContentByKey(key, value));
            sidebarTitles.push(key);
        }
    });

    // const pageContent = [
    // <ProductItemsBoxWithTabs title="Wuxal trial results" data={tabsData} />,
    // <ProductCatalogBox
    //     title="Wuxal catalog"
    //     image={wuxalCatalog}
    //     text={'Check out our Wuxal product catalog for detailed information on composition and usage.'}
    // />,
    // ];

    const arrLength = pageContent.length;
    const [refs, setRefs] = useState([]);

    useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || createRef()),
        );
    }, [arrLength]);

    useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <WithSidebar Sidebar={<NavigationSideBar activeIndex={activeIndex} refs={refs} items={sidebarTitles} />}>
            {pageContent.map((item, index) => (
                <div ref={refs[index]} key={index}>
                    <NavigationSectionWrapper index={index} setData={setSectionsData}>
                        {item}
                    </NavigationSectionWrapper>
                </div>
            ))}
        </WithSidebar>
    );
};
export default AboutProductPageContent;
